export const PUESTOS = [
    "Mando medio",
    "Mantenimiento",
    "Almacén",
    "Molinero",
    "Vigilancia",
    "Seguridad e Higiene",
    "Cocina",
    "Limpieza",
    "Inyección",
    "Embarques",
    "Producción 1er turno",
    "Control de calidad",
    "Producción 2do turno"
];
